import React, { useState } from 'react';
import legaldocpic from "../../../../assets/images/A4 .png";
import Button from '../../Button/Button';
import Checkbox from '../../Formik/Checkbox/Checkbox';
import Modal from '../Modal/Modal';
import styles from "./LegalDisclosures.module.scss";
import { useFormik } from 'formik';
import KycVerification from '../KycVerification/KycVerification';

const LegalDisclosures = ({ show, handleClose }) => {
    const [showVerification, setShowVerification] = useState(false);
    const formik = useFormik({
        initialValues: {
            disclaimer: false,
        },
        onSubmit: values => {
            setShowVerification(true);
            handleClose();
        }
    })
    return (
        <>
            <Modal className={styles.LegalDisclosures_modal}
                show={show}
                handleClose={handleClose}
                title="Legal disclosures">
                <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <div className={styles.direct_sec}>
                        <div className={styles.deposit_img}>
                            <img src={legaldocpic} alt="A4-pic" />
                        </div>
                        <Checkbox
                            name="disclaimer"
                            label="Disclaimer: I read the documents carefully. If you choose to get paid in STBL tokens, STBL will automatically convert your paycheck from US dollars to STBL tokens with no trading fees on direct deposit."
                            {...formik.getFieldProps("disclaimer")}
                        />
                    </div>
                    <Button
                        fluid
                        className={styles.submit_btn}
                        type="button"
                        disabled={!formik.values.disclaimer}
                        onClick={(e) => {
                            formik.handleSubmit(e);
                        }}
                    >Accept</Button>
                </form>
            </Modal>
            <KycVerification
                show={showVerification}
                handleClose={() => setShowVerification(false)}
            />
        </>
    )
}

export default LegalDisclosures